import useBreakpoint from '../../hooks/useBreakpoint';
import React, { useState, useEffect } from 'react';
import { Menu, Layout, Dropdown, Button } from 'antd';
import { DownOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import { Modal } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import logo_toscana from "../../icons/Regione.png";
import logo_fse from "../../icons/FSE-logo.png";
import scritta_toscana from "../../icons/logo-regione-toscana.png";
import logo_estar from "../../icons/Estar.png";
import { useAuth } from '../../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import TransText from "../../translation/trans_tag";
import { IoMdHome } from "react-icons/io";
import { RxHamburgerMenu } from "react-icons/rx";
import { IoIosLogOut } from "react-icons/io";

const { Header } = Layout;

const Navbar = (props) => {

  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [activeNav, setActiveNav] = useState('');

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  const confirmLogout = () => {
    setShowLogoutModal(false);
    logout();
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };


  // Handler for logo click: redirect based on user role
  const handleLogoClick = () => {
    if (!user) {
      navigate('/login');
    } else if (user.role === 'admin') {
      navigate('/admin');
    } else if (user.role === 'tutor') {
      navigate('/homepage');
    } else {
      navigate('/');
    }
  };

  // Controlla il percorso corrente quando il componente viene montato
  useEffect(() => {
    // Imposta lo stato attivo in base al percorso corrente
    if (location.pathname === '/formazione') {
      setActiveNav('formazione');
    } else {
      setActiveNav('');
    }
  }, [location.pathname]);

  const { breakpoint } = useBreakpoint();

  // Sidebar for small screens (breakpoint 'sm' or 'md')
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Pass showUserDropdown = true for topbar, false for sidebar
  const renderNavLinks = () => (
    <>
      <a 
        href="/homepage"
        className={`d-flex align-items-center ${location.pathname === '/homepage' ? 'color-icon-3' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/homepage');
          setSidebarOpen(false);
        }} 
        style ={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
      >
        <IoMdHome className={`me-2 align-middle ${location.pathname === '/homepage' ? ' icon-size-XL' : ' icon-size-L '}`} />
      </a>
      {/* <a 
        href="/elenco-discenti"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/elenco-discenti' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/elenco-discenti', {
            state: {
              returnPath: location.pathname !== '/elenco-discenti' ? location.pathname : '/homepage',
              ...location.state // preserve any existing state
            }
          });
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      > */}
        {/* <FaUserMd className="me-1 icon-size-L align-middle" /> */}
        {/* <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.discenti" />
        </span>
      </a> */}
      <a 
        href="/formazione"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/formazione' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/formazione', {
            state: {
              returnPath: location.pathname !== '/formazione' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.formazione" />
        </span>
      </a>
      <a 
        href="/guida-tool"
        className={`d-flex align-items-center nav-button px-1 ${location.pathname === '/guida-tool' ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/guida-tool', {
            state: {
              returnPath: location.pathname !== '/guida-tool' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }} 
        style={{ textDecoration: 'none', color: 'inherit' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.tutorial" />
        </span>
      </a>
      <Button onClick={() => { setSidebarOpen(false); handleLogout(); }} 
        type="text"
        className="text-danger px-0"
      >
        <IoIosLogOut size={20} />
      </Button>
      {/* {showUserDropdown ? (
        <Dropdown
          menu={{
            items: dropdownItems.map(({ key, icon, label, onClick }) => ({
              key,
              icon,
              label: (
                <span
                  className="lh-sm fs-6 py-1 d-flex align-items-center"
                  style={{ cursor: 'pointer' }}
                  onClick={onClick}
                >
                  {label}
                </span>
              ),
              onClick,
            })),
          }}
          trigger={['click']}
          className="d-flex align-items-center"
          onOpenChange={(open) => setActiveNav(open ? 'user' : '')}
        >
          <div className={`d-flex align-items-center nav-button px-1 user-dropdown ${activeNav === 'user' ? 'active' : ''}`}>
            <span className="fs-6 align-middle fw-semibold">
              {(() => {
                const getInitials = (firstName, lastName) => {
                  let firstNameParts = [];
                  let initials = "";
                  if (firstName) {
                    firstNameParts = firstName.trim().split(/\s+/);
                    firstNameParts.forEach(part => {
                      if (part && part.length > 0) {
                        initials += part.charAt(0).toUpperCase();
                      }
                    });
                  }
                  if (lastName && lastName.trim()) {
                    const firstLastNamePart = lastName.trim().split(/\s+/)[0];
                    if (firstLastNamePart && firstLastNamePart.length > 0) {
                      initials += firstLastNamePart.charAt(0).toUpperCase();
                    }
                  }
                  return initials || "";
                };
                if (user && (user.firstName || user.name || user.lastName || user.surname)) {
                  const firstName = user.firstName || user.name || '';
                  const lastName = user.lastName || user.surname || '';
                  return getInitials(firstName, lastName);
                } else {
                  const token = localStorage.getItem('token');
                  if (token) {
                    try {
                      const payload = JSON.parse(atob(token.split('.')[1]));
                      const firstName = payload.firstName || payload.name || '';
                      const lastName = payload.lastName || payload.surname || '';
                      return getInitials(firstName, lastName);
                    } catch {
                      return '';
                    }
                  }
                  return '';
                }
              })()}
            </span>
            <DownOutlined className="ms-2 icon-size-M" style={{ cursor: 'pointer' }} />
          </div>
        </Dropdown>
      ) : null} */}
    </>
  );
          // Topbar nav links (icon for homepage)
  const renderTopbarLinks = () => (
    <>
      <a
        href="/homepage"
        className={`d-flex align-items-center gap-2 py-2 px-3 rounded nav-link-topbar ${location.pathname === '/homepage' ? 'active-topbar' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/homepage');
          setSidebarOpen(false);
        }}
        style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit', fontWeight: 600, fontSize: 17, transition: 'background 0.2s' }}
      >
        <IoMdHome className="me-2 icon-size-L align-middle" />
        <span>Homepage</span>
      </a>
      <a
        href="/formazione"
        className={`d-flex align-items-center gap-2 py-2 px-3 rounded nav-link-topbar ${location.pathname === '/formazione' ? 'active-topbar' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/formazione', {
            state: {
              returnPath: location.pathname !== '/formazione' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }}
        style={{ textDecoration: 'none', color: 'inherit', fontWeight: 500, fontSize: 16, transition: 'background 0.2s' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.formazione" />
        </span>
      </a>
      <a
        href="/guida-tool"
        className={`d-flex align-items-center gap-2 py-2 px-3 rounded nav-link-topbar ${location.pathname === '/guida-tool' ? 'active-topbar' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/guida-tool', {
            state: {
              returnPath: location.pathname !== '/guida-tool' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }}
        style={{ textDecoration: 'none', color: 'inherit', fontWeight: 500, fontSize: 16, transition: 'background 0.2s' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.tutorial" />
        </span>
      </a>
      {/* <a
        href="/settings"
        className={`d-flex align-items-center gap-2 py-2 px-3 rounded nav-link-topbar ${location.pathname === '/settings' ? 'active-topbar' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/settings', {
            state: {
              returnPath: location.pathname !== '/settings' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }}
        style={{ textDecoration: 'none', color: 'inherit', fontWeight: 500, fontSize: 16, transition: 'background 0.2s' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.settings" />
        </span>
      </a> */}
      {/* <a
        href="/issues"
        className={`d-flex align-items-center gap-2 py-2 px-3 rounded nav-link-topbar ${location.pathname === '/issues' ? 'active-topbar' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          navigate('/issues', {
            state: {
              returnPath: location.pathname !== '/issues' ? location.pathname : '/homepage',
              ...location.state
            }
          });
          setSidebarOpen(false);
        }}
        style={{ textDecoration: 'none', color: 'inherit', fontWeight: 500, fontSize: 16, transition: 'background 0.2s' }}
      >
        <span className="fs-6 align-middle fw-semibold">
          <TransText i18nKey="general.navbar.issues" />
        </span>
      </a> */}
      <div className="mt-2 pt-2 border-top">
        <div className="d-flex flex-column justify-content-start">
          <Button type="text" className="text-start w-100 text-danger fw-bold" style={{ fontSize: 15 }} onClick={() => { setSidebarOpen(false); handleLogout(); }}>
            <TransText i18nKey="general.navbar.logout" />
          </Button>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Header className="custom-header">
        <div className="d-flex align-items-center justify-content-between w-100">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              handleLogoClick();
            }}
            className="d-flex align-items-center cursor-pointer"
            style={{ cursor: 'pointer', textDecoration: 'none', color: 'inherit' }}
          >
            <div className="navbar-logo-wrapper">
              <img src={logo_toscana} alt="Logo Toscana" className="navbar-logo" />
            </div>
            <div className="navbar-logo-wrapper-wide ms-1 mt-1">
              <img src={scritta_toscana} alt="Logo Toscana" className="navbar-logo navbar-logo-wide" />
            </div>
            <div className="navbar-logo-wrapper ms-1">
              <img src={logo_estar} alt="Logo Estar" className="navbar-logo" />
            </div>
            <div className="navbar-logo-wrapper ms-2">
              <img src={logo_fse} alt="Logo Toscana" className="navbar-logo" />
            </div>
          </a>
          {/* Hamburger for screens < 1200px (sm, md) */}
          {(breakpoint === 'sm') && (
            <div className="d-flex align-items-center flex-row">
            <Button
              type="text"
              className="d-lg-none ms-2"
              onClick={() => setSidebarOpen(!sidebarOpen)}
              aria-label="Apri menu"
            >
                <RxHamburgerMenu size={28} />
            </Button>
            </div>
          )}
          {/* Topbar nav for screens >= 1200px (lg, xl) */}
          {(breakpoint === 'lg' || breakpoint === 'xl' || breakpoint === 'md') && (
            <div className="d-flex align-items-center flex-row gap-2 gap-xxl-3 ">
              {renderNavLinks()}
            </div>
          )}
        </div>
      </Header>
      {/* Sidebar for screens < 1200px (sm, md) */}
      {(breakpoint === 'sm' ) && sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', zIndex: 1999, background: 'rgba(0,0,0,0.15)' }}>
          <div className="sidebar bg-white p-4" onClick={e => e.stopPropagation()} style={{ position: 'fixed', top: 0, right: 0, height: '100vh', width: 260, zIndex: 2000, boxShadow: '2px 0 8px rgba(0,0,0,0.15)' }}>
            <div className="d-flex flex-column gap-3">
              {renderTopbarLinks()}
              {/* User menu expanded directly */}
            </div>
          </div>
        </div>
      )}
      {/* Modal di conferma logout */}
      <Modal show={showLogoutModal} onHide={cancelLogout} top>
        <Modal.Body>
          <span className="d-flex align-items-center">
            <ExclamationCircleFilled className='icon-alert ms-2 me-2' />
            <span className="fs-5">
              <TransText i18nKey="general.login.logoutTitle" />
            </span>
          </span>
        </Modal.Body>
        <div className="d-flex align-items-center justify-content-end gap-2 p-3 pt-0">
          <Button
            onClick={cancelLogout}
            className='button-responsive fs-5'
          >
            <TransText i18nKey="general.actions.cancel" />
          </Button>
          <Button
            type="primary"
            onClick={confirmLogout}
            className='button-responsive button-color fs-5'
          >
            <TransText i18nKey="general.actions.confirm" />
          </Button>
        </div>
      </Modal>
    </>
  );
  
};

export default Navbar;